import React from 'react'
import { withProfile } from 'redux/enhancers'
import { injectIntl } from 'react-intl'
import { Result, Button } from 'antd'
import { ImportOutlined, SyncOutlined } from '@ant-design/icons'

import style from './style.module.scss'

class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  onLogOut = () => {
    // eslint-disable-next-line no-undef
    Sentry.captureMessage('Пользователь увидел ошибку и нажал кнопку выхода');
    this.props.logInReset();
  }

  onRefresh = () => {
    // eslint-disable-next-line no-undef
    Sentry.captureMessage('Пользователь увидел ошибку и перезагрузил страницу');
    document.location.reload(true/* reload page without the browser cache */)
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-undef
    Sentry.captureException(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { intl: { formatMessage } } = this.props

      return (
        <div className={style.errorWrapper}>
          <Result
            status="warning"
            title={formatMessage({ id: 'components.error-boundary.title' })}
            extra={(
              <>
                <p>{formatMessage({ id: 'components.error-boundary.message-sent' })}</p>
                <span>{formatMessage({ id: 'components.error-boundary.you-can' })}</span>
                <Button
                  onClick={this.onLogOut}
                  icon={<ImportOutlined />}
                  size="small"
                >
                  {formatMessage({ id: 'components.error-boundary.re-login' })}
                </Button>
                <span>{formatMessage({ id: 'components.error-boundary.or' })}</span>
                <Button
                  onClick={this.onRefresh}
                  icon={<SyncOutlined />}
                  size="small"
                >
                  {formatMessage({ id: 'components.error-boundary.refresh-page' })}
                </Button>,
                <p>{formatMessage({ id: 'components.error-boundary.solve-yourself' })}</p>
              </>
            )}
          />
        </div>
      )
    }

    return this.props.children;
  }
}

export default withProfile(injectIntl(ErrorBoundary))
